export default __webpack_public_path__ + "static/media/sitting.7bed8349.svg";